export class Client {
  name: string;
  email: string;
  phone: string;
  position: string;
  school: string;
}
